import { Component } from '@angular/core';
import { FlowToolsService } from '@core/services/flow-tools/flow-tools.service';

/**
 * Tester del Flow CIMA (CIMA_TOKEN). A diferencia de Strive/Price/Flyers, los
 * campos que espera la API externa de CIMA (CIMA_API_URL) son un contrato del
 * partner que NO está documentado en este repo — por eso el payload se
 * ingresa como JSON crudo en vez de un formulario con campos fijos.
 *
 * Llama a POST /chatBot/cima-test en backend_v1 (agregado en
 * chatBotControllers.js/chatbot.routes.js) — sin depender de chatbot_v1.
 * Requiere CIMA_API_URL/CIMA_API_TOKEN en backend_v1/.env.
 */
@Component({
  selector: 'app-cima-tester',
  templateUrl: './cima-tester.component.html',
  styleUrls: ['./cima-tester.component.scss'],
})
export class CimaTesterComponent {
  payloadJson = '{\n  \n}';
  isLoading = false;
  errorMessage = '';
  result: { score?: number; group?: string; raw?: any } | null = null;

  constructor(private flowToolsService: FlowToolsService) {}

  onSubmit(): void {
    let payload: Record<string, any>;
    try {
      payload = JSON.parse(this.payloadJson || '{}');
    } catch {
      this.errorMessage = 'El JSON del payload no es válido.';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';
    this.result = null;

    this.flowToolsService.testCima(payload).subscribe(
      (response) => {
        this.isLoading = false;
        if (response.ok) {
          this.result = { score: response.score, group: response.group, raw: response.raw };
        } else {
          this.errorMessage = response.msg || 'La consulta a CIMA no devolvió resultado.';
        }
      },
      (error) => {
        this.isLoading = false;
        this.errorMessage = `Error: ${error.error?.msg || error.message}`;
      },
    );
  }

  reset(): void {
    this.payloadJson = '{\n  \n}';
    this.result = null;
    this.errorMessage = '';
  }
}
